import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function PainSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section className="w-full" style={{
    backgroundColor: '#FFF8F0'
  }} data-id="element-129">
      <div className="max-w-3xl mx-auto px-6 py-12 md:py-18" ref={ref} data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} data-id="element-131">
          {/* Personal letter style copy */}
          <div className="space-y-5" data-id="element-132">
            <p className="font-serif-display text-xl md:text-2xl leading-relaxed" style={{
            color: '#1A1A1A'
          }} data-id="element-133">
              Sé lo que se siente mirar el recibo de la renta o la cuenta de la
              luz y sentir un nudo en el estómago.
            </p>

            <p className="font-body text-lg md:text-xl leading-relaxed" style={{
            color: '#3D3D3D'
          }} data-id="element-134">
              Vivir en Estados Unidos es caro, y a veces, un solo sueldo no
              alcanza.
            </p>

            <p className="font-body text-lg md:text-xl leading-relaxed" style={{
            color: '#3D3D3D'
          }} data-id="element-135">
              Miraste tu máquina de coser en la esquina. Pensaste:{' '}
              <em className="font-serif-display" style={{
              color: '#1A1A1A'
            }} data-id="element-136">
                «Ojalá pudiera ganar algo con ella»
              </em>
              .
            </p>

            <p className="font-body text-lg md:text-xl leading-relaxed" style={{
            color: '#3D3D3D'
          }} data-id="element-137">
              Pero no tienes tiempo para hacer vestidos complicados, ni clientes
              que quieran "alta costura".
            </p>
          </div>

          {/* Stitch divider */}
          <hr className="stitch-divider my-8 md:my-10" data-id="element-138" />

          {/* The truth reveal */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.7,
          delay: 0.3,
          ease: 'easeOut'
        }} data-id="element-139">
            <p className="font-serif-display font-bold text-2xl md:text-3xl leading-snug mb-6" style={{
            color: '#B8860B'
          }} data-id="element-140">
              Aquí está la verdad que nadie te dice:
            </p>

            <p className="font-body text-lg md:text-xl leading-relaxed" style={{
            color: '#3D3D3D'
          }} data-id="element-141">
              Los americanos no quieren ropa nueva a medida...
            </p>

            <p className="font-serif-display font-bold text-2xl md:text-3xl leading-snug mt-4" style={{
            color: '#1A1A1A'
          }} data-id="element-142">
              Quieren que su ropa de marca les quede bien.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}